import { h } from 'preact'
import { i18n } from 'i18n/i18n'
import { TFunctionDetailedResult } from 'i18next'

interface ErrorSpinnerProps {
  errorText?: TFunctionDetailedResult
}

const ErrorSpinner = ({ errorText }: ErrorSpinnerProps) => {
  const text = errorText || i18n('calculator.spinnerError.generic')
  return (
    <div className="spinner">
      <div className="spinner__holder">
        <div className="spinner__animation" />
        <p className="spinner__text">{text}</p>
      </div>
    </div>
  )
}

export default ErrorSpinner
